import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    doFetch,
    apiError,
    doPut,
    doCreate,
    s3upload
} from '../redux/api/actions';
import { useParams, useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import {
    CATEGORIES,
    CURRENT_RECIPE,
    RECIPE_UPDATE,
    GET_PRESIGNED_IMAGE_URLS
} from '../redux/api/constants';
import ImageUploader from './imageUploader';
import withLayout from './withLayout';

function Recipe() {
    const navigate = useNavigate();

    const { category_id, recipe_id } = useParams();
    const [name, updateName] = useState("");
    const [source, updateSource] = useState("");
    const [ingredients, updateIngredients] = useState("");
    const [directions, updateDirections] = useState("");
    const [selected_category_id, updateCategory] = useState(1);
    const [imageFiles, setImageFiles] = useState([]);

    const dispatch = useDispatch()
    const currentRecipe = useSelector(state => state.API.currentRecipe);
    const me = useSelector(state => state.API.me);
    const authToken = useSelector(state => state.Auth.accessToken);
    const categories = useSelector(state => state.API.categories);
    const presignedImageUrls = useSelector(state => state.API.presignedImageUrls);

    useEffect(() => {
        dispatch(doFetch(
            CURRENT_RECIPE,
            `recipes/${recipe_id}`
        ))

        dispatch(doFetch(
            CATEGORIES,
            'categories',
        ))

    }, [dispatch, recipe_id]);

    /* Text Area Autosize */

    function useAutosizeTextArea(textAreaRef, value) {
        useEffect(() => {
            if (textAreaRef && textAreaRef.current) {
                const element = textAreaRef.current;
                element.style.height = '0px'; // reset height
                element.style.height = element.scrollHeight + 'px'; // set to full scroll height
            }
        }, [textAreaRef, value]);
    }


    const ingredientsRef = useRef(null);
    const directionsRef = useRef(null);

    useAutosizeTextArea(ingredientsRef, ingredients);
    useAutosizeTextArea(directionsRef, directions);

    /* Photo Upload */

    /* if they upload an image, get the presigned urls for it */
    const handleImageUpload = (images) => {
        // Get the presigned URLs first
        // Then upload the images to the presigned URLsjj
        const fileList = Array.from(images);
        const fileNames = fileList.map((f) => f.name);

        dispatch(doCreate(
            GET_PRESIGNED_IMAGE_URLS,
            "images/presigned-urls",
            authToken,
            { images: fileNames }
        ))
        setImageFiles(fileList);
    }

    const updateRecipe = (e) => {
        e.preventDefault();
        if (me.id !== currentRecipe.user_id && !me.is_superuser) {
            dispatch(apiError("You are not authorized to edit this recipe"));
            return;
        }
        if (imageFiles && imageFiles.length > 0) {
            // upload the images to the presigned URLs
            dispatch(s3upload(imageFiles, presignedImageUrls));
        }
        const cleanedUrls = presignedImageUrls.map(u => new URL(u).origin + new URL(u).pathname).join(',');

        dispatch(doPut(
            RECIPE_UPDATE,
            `recipes/${recipe_id}`,
            authToken,
            {
                name: name,
                source: source,
                ingredients: ingredients,
                directions: directions,
                category_id: category_id,
                food_image: cleanedUrls || currentRecipe.food_image,
            },
            navigate
        ))

    }

    useEffect(() => {
        if (currentRecipe) {
            updateName(currentRecipe.name || "");
            updateSource(currentRecipe.source || "");
            updateIngredients(currentRecipe.ingredients || "");
            updateDirections(currentRecipe.directions || "");
            updateCategory(currentRecipe.category_id || 1);
            setImageFiles(currentRecipe.food_image ? [currentRecipe.food_image] : []);
        }
    }, [currentRecipe]);

    return (
        <div >
            {currentRecipe && (
                <>
                    <Link to={`/categories/${category_id}`}>{currentRecipe.category}</Link> / {name}
                    <div className="card my-4 shadow-sm border-0">
                        <div className="card-body bg-light-cream rounded">
                            <h2 className="card-title text-sienna">{currentRecipe.category} / {name}</h2>
                            <form onSubmit={updateRecipe}>
                                <fieldset>
                                    <div className="form-group">
                                        <label htmlFor="name" className="form-label"> Recipe Name</label>
                                        <input type="text"
                                            id="name"
                                            name="name"
                                            value={name}
                                            className="form-control"
                                            onChange={(e) => updateName(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="source" className="form-label">Source</label>
                                        <input type="text"
                                            id="source"
                                            name="source"
                                            className="form-control"
                                            value={source}
                                            onChange={(e) => updateSource(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="ingredients" className="form-label">Ingredients</label>
                                        <textarea
                                            id="ingredients"
                                            name="ingredients"
                                            className="form-control"
                                            value={ingredients}
                                            rows={2 + ingredients.split("\n").length}
                                            onChange={(e) => updateIngredients(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="directions" className="form-label">Directions</label>
                                        <textarea
                                            id="directions" name="directions"
                                            className="form-control"
                                            value={directions}
                                            rows={2 + directions.split("\n").length}
                                            onChange={(e) => updateDirections(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="category" className="form-label">Category</label>
                                        <select className="form-select" id="category" value={selected_category_id} onChange={(e) => updateCategory(e.target.value)}>
                                            {categories && categories.map((category, index) => (
                                                <option key={index} value={category.id}>{category.title}</option>
                                            ))}
                                        </select>

                                    </div>
                                    <ImageUploader imageUrls={currentRecipe.food_image ? [currentRecipe.food_image] : []} imageUploadFunc={handleImageUpload} />
                                    <div className="form-group">
                                        <button type="submit" className="btn mt-4 btn-primary">Update Recipe</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </>
            )}
        </div >
    );
}
export default withLayout(Recipe);